import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '6px 0',
    color: 'var(--color-neutral-500)'
  },
  line: {
    flex: 1,
    height: '1px',
    background: 'var(--border-neutral-color, var(--color-neutral-200))'
  },
  label: {
    fontSize: '11px',
    lineHeight: 1.2,
    textAlign: 'center',
    userSelect: 'none'
  }
}))

/**
 * Horizontal divider rendered inline in the chat transcript when the
 * agent's context compaction middleware fires. Two flavors keyed by
 * `metadata.kind`:
 *  - 'summarize' — older turns were summarized by a secondary LLM.
 *  - 'trim' — older turns were dropped by the hard-cap trim guard.
 */
function CompactionDivider ({ metadata }) {
  const classes = useStyles()

  const kind = metadata?.kind || 'summarize'
  const messagesSummarized = metadata?.messagesSummarized

  let label
  if (kind === 'trim') {
    label = typeof messagesSummarized === 'number' && messagesSummarized > 0
      ? `Earlier ${messagesSummarized} messages dropped to stay under the model's input limit`
      : 'Earlier messages dropped to stay under the model\'s input limit'
  } else {
    label = typeof messagesSummarized === 'number' && messagesSummarized > 0
      ? `Earlier context compacted — ${messagesSummarized} messages summarized`
      : 'Earlier context compacted'
  }

  return (
    <div className={classes.root}>
      <span className={classes.line} />
      <span className={classes.label}>{label}</span>
      <span className={classes.line} />
    </div>
  )
}

CompactionDivider.propTypes = {
  metadata: PropTypes.shape({
    kind: PropTypes.oneOf(['summarize', 'trim']),
    tokensBefore: PropTypes.number,
    tokensAfter: PropTypes.number,
    messagesSummarized: PropTypes.number
  })
}

export default CompactionDivider
